import { render } from "./fixPass.vue?vue&type=template&id=15fd7bfe&scoped=true"
import script from "./fixPass.vue?vue&type=script&lang=js"
export * from "./fixPass.vue?vue&type=script&lang=js"

import "./fixPass.vue?vue&type=style&index=0&id=15fd7bfe&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fd7bfe"]])

export default __exports__